export let BASE_URL = "https://ftnotify.monexfintech.com/";
export let API_DOC_URL = "https://apidoc.bankoyo.com/";
export let DOCUMENTATION_URL = "https://connect.bankoyo.com/";
export let CONTACTBASE_URL = "https://qagateway.bankoyo.com/";
